"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
function propertyDefinition() {
    return [
        {
            sort_no: 1,
            name: "outletheadermaterialtype",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [
                {
                    sort_no: 1,
                    value: {
                        type: "integer",
                        value: 1
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 2,
                    value: {
                        type: "integer",
                        value: 2
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 3,
                    value: {
                        type: "integer",
                        value: 3
                    },
                    property_filter: property_1.PropertyFilter.Empty
                }
            ]
        },
        {
            sort_no: 2,
            name: "outletheadernrofheaders",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [
                {
                    sort_no: 1,
                    value: {
                        type: "integer",
                        value: 1
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 2,
                    value: {
                        type: "integer",
                        value: 2
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 3,
                    value: {
                        type: "integer",
                        value: 3
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 4,
                    value: {
                        type: "integer",
                        value: 4
                    },
                    property_filter: property_1.PropertyFilter.Empty
                }
            ]
        },
        {
            sort_no: 3,
            name: "outletheaderthickness",
            group: "",
            quantity: "Length",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 4,
            name: "outletheaderdiameter",
            group: "",
            quantity: "Length",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
//# sourceMappingURL=outletheader-definition.js.map